import { api } from './api';
import { TiTiTinderCantada, TiTiTinderConfig } from '../types/tititinder';

export async function getTiTiTinderConfig(): Promise<TiTiTinderConfig> {
  const response = await api.get('/tititinder/config');
  return response.data;
}

export async function setTiTiTinderAberto(aberto: boolean): Promise<TiTiTinderConfig> {
  const response = await api.patch('/tititinder/config', { aberto });
  return response.data;
}

export async function enviarCantada(
  id_militar_destinatario: string,
  cantada: string,
  anonimo: boolean
): Promise<TiTiTinderCantada> {
  const response = await api.post(`/tititinder/${id_militar_destinatario}/cantadas`, {
    cantada,
    anonimo,
  });
  return response.data;
}

export async function listarCantadas(): Promise<TiTiTinderCantada[]> {
  const response = await api.get('/tititinder/cantadas');
  return response.data;
}
